export const schoolProgramHeaders = [
    {
        id: "delivery_type",
        numeric: false,
        disablePadding: true,
        label: "Delivery Type"
    },
    {
        id: "program_type",
        numeric: false,
        disablePadding: true,
        label: "Program Type"
    },
    {
        id: "school_name",
        numeric: false,
        disablePadding: true,
        label: "School"
    },
    {
        id: "day",
        numeric: false,
        disablePadding: true,
        label: "Day"
    },
    {
        id: "program_time",
        numeric: false,
        disablePadding: true,
        label: "Time"
    },
    {
        id: "program_duration",
        numeric: false,
        disablePadding: true,
        label: "Duration"
    },
    {
        id: "sessions",
        numeric: false,
        disablePadding: true,
        label: "Sessions"
    },
    {
        id: "course_abbr",
        numeric: false,
        disablePadding: true,
        label: "Stream (Abbr)"
    },
    {
        id: "student_id",
        numeric: false,
        disablePadding: true,
        label: "Student ID"
    },
    {
        id: "student_name",
        numeric: false,
        disablePadding: true,
        label: "Student Name"
    },
    {
        id: "parent_name",
        numeric: false,
        disablePadding: true,
        label: "Parent Name"
    },
    {
        id: "phone",
        numeric: false,
        disablePadding: true,
        label: "Phone Number"
    },
    {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email Address"
    },
    {
        id: "alternate_emails",
        numeric: false,
        disablePadding: true,
        label: "Alternate Emails"
    },
    {
        id: "dob",
        numeric: false,
        disablePadding: true,
        label: "DOB"
    },
    {
        id: "allergies",
        numeric: false,
        disablePadding: true,
        label: "Allergies"
    },
    {
        id: "special_need",
        numeric: false,
        disablePadding: true,
        label: "Special Needs"
    }
]
